import Icon from "~/components/shared/Icon";
import { State, WaitStep } from "~/lib/pipeline";
import { StepLink } from "~/components/build/Show/pages/steps/list/components/TreeNode/StepLink";
import { resolveStepUrl } from "~/components/build/Show/lib/urlForView";
import useCurrentJobOrStep from "~/components/build/Show/lib/useCurrentJobOrStep";
import {
  TreeNode,
  TreeNodeType,
} from "~/components/build/Show/pages/steps/list/components/TreeNode";

interface Props {
  step: WaitStep;
  depth?: number;
}

export function WaitStepItem({ step, depth }: Props) {
  const { currentStep } = useCurrentJobOrStep();

  return (
    <StepLink
      title="Wait"
      to={resolveStepUrl(step.uuid)}
      type={step.type}
      className="items-center justify-center gap-2"
      active={step.uuid === currentStep?.uuid}
      depth={depth}
      state={step.state}
    >
      <div className="flex-1 border-b border-gray-400" />
      <span className="flex items-center gap-1 py-2">
        <Icon
          icon={
            step.state === State.Finished
              ? "heroicons/outline/chevron-down"
              : "heroicons/solid/pause"
          }
          className="h-3 w-3"
        />
      </span>
      <div className="flex-1 border-b border-gray-400" />
    </StepLink>
  );
}

export const createWaitStepNode = (step: WaitStep): TreeNode => ({
  id: step.uuid,
  type: TreeNodeType.StepWait,
  render: (props) => <WaitStepItem step={step} {...props} />,
});
